import { render, staticRenderFns } from "./commoditySortingOperation.vue?vue&type=template&id=174c2526&scoped=true"
import script from "./commoditySortingOperation.vue?vue&type=script&lang=js"
export * from "./commoditySortingOperation.vue?vue&type=script&lang=js"
import style0 from "./commoditySortingOperation.vue?vue&type=style&index=0&id=174c2526&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174c2526",
  null
  
)

export default component.exports